import { GRACKLE_COLORS } from '@/lib/theme'
import ProTip from '../ProTip'

export default function KeyboardShortcutsSection() {
  return (
    <>
      <p className="text-sm text-muted-foreground mb-3">
        Keyboard shortcuts help you navigate faster without reaching for the mouse. Even learning a
        few of these can save you time across a busy day of calls and data entry.
      </p>

      <section aria-labelledby="shortcuts-nav-heading">
        <h3 id="shortcuts-nav-heading" className="font-semibold mb-3">
          Navigation
        </h3>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b">
              <th
                scope="col"
                className="py-2 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider"
              >
                Action
              </th>
              <th
                scope="col"
                className="py-2 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider"
              >
                Shortcut
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b">
              <td className="py-2 text-muted-foreground">Move between interactive elements</td>
              <td className="py-2 text-right">
                <kbd className="px-2 py-1 text-xs font-semibold bg-muted border border-border rounded">
                  Tab
                </kbd>
              </td>
            </tr>
            <tr className="border-b">
              <td className="py-2 text-muted-foreground">Move backwards between elements</td>
              <td className="py-2 text-right">
                <span className="inline-flex gap-1 items-center">
                  <kbd className="px-2 py-1 text-xs font-semibold bg-muted border border-border rounded">
                    Shift
                  </kbd>
                  <span className="text-muted-foreground">+</span>
                  <kbd className="px-2 py-1 text-xs font-semibold bg-muted border border-border rounded">
                    Tab
                  </kbd>
                </span>
              </td>
            </tr>
            <tr className="border-b">
              <td className="py-2 text-muted-foreground">Activate buttons and links</td>
              <td className="py-2 text-right">
                <kbd className="px-2 py-1 text-xs font-semibold bg-muted border border-border rounded">
                  Enter
                </kbd>
              </td>
            </tr>
            <tr>
              <td className="py-2 text-muted-foreground">Close modals, dropdowns, and dialogs</td>
              <td className="py-2 text-right">
                <kbd className="px-2 py-1 text-xs font-semibold bg-muted border border-border rounded">
                  Esc
                </kbd>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <section aria-labelledby="shortcuts-actions-heading" className="mt-4">
        <h3 id="shortcuts-actions-heading" className="font-semibold mb-3">
          Quick Actions
        </h3>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b">
              <th
                scope="col"
                className="py-2 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider"
              >
                Action
              </th>
              <th
                scope="col"
                className="py-2 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider"
              >
                Shortcut
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b">
              <td className="py-2 text-muted-foreground">Open Global Search</td>
              <td className="py-2 text-right">
                <span className="inline-flex gap-1 items-center">
                  <kbd className="px-2 py-1 text-xs font-semibold bg-muted border border-border rounded">
                    Ctrl
                  </kbd>
                  <span className="text-muted-foreground">+</span>
                  <kbd className="px-2 py-1 text-xs font-semibold bg-muted border border-border rounded">
                    K
                  </kbd>
                </span>
              </td>
            </tr>
            <tr className="border-b">
              <td className="py-2 text-muted-foreground">Select / deselect checkboxes</td>
              <td className="py-2 text-right">
                <kbd className="px-2 py-1 text-xs font-semibold bg-muted border border-border rounded">
                  Space
                </kbd>
              </td>
            </tr>
            <tr>
              <td className="py-2 text-muted-foreground">Navigate within dropdown menus</td>
              <td className="py-2 text-right">
                <span className="inline-flex gap-1 items-center">
                  <kbd className="px-2 py-1 text-xs font-semibold bg-muted border border-border rounded">
                    &uarr;
                  </kbd>
                  <kbd className="px-2 py-1 text-xs font-semibold bg-muted border border-border rounded">
                    &darr;
                  </kbd>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <div className="mt-4">
        <ProTip>
          <span className="font-medium">Start with one:</span> Just learning{' '}
          <kbd
            className="px-1.5 py-0.5 text-xs font-semibold rounded"
            style={{
              backgroundColor: GRACKLE_COLORS.paleGrey,
              color: GRACKLE_COLORS.navy,
              border: `1px solid ${GRACKLE_COLORS.powderBlue}`,
            }}
          >
            Ctrl
          </kbd>{' '}
          +{' '}
          <kbd
            className="px-1.5 py-0.5 text-xs font-semibold rounded"
            style={{
              backgroundColor: GRACKLE_COLORS.paleGrey,
              color: GRACKLE_COLORS.navy,
              border: `1px solid ${GRACKLE_COLORS.powderBlue}`,
            }}
          >
            K
          </kbd>{' '}
          for Global Search will make a noticeable difference in your daily workflow. Add more
          shortcuts as you get comfortable.
        </ProTip>
      </div>
    </>
  )
}
